import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  constructor(private authService: AuthService) {} // Inject the AuthService
  ngOnInit(): void {
    this.MsLogin();
  }
  
  MsLogin() {
    this.authService.microsoftLogin(); // Call the microsoftLogin() method from the AuthService
  }
}
